import { EMPTY_STRING } from '@rotomeca/utils';
import BnumElement from '../../bnum-element';
import { Define, Light, SetAttr } from '../../../core/decorators';
import { TAG_FOLDER_LIST } from '../../../core/utils/constants/tags';

/**
 * Représente un élément personnalisé de type liste de dossiers (Folder List) pour l'interface Bnum.
 * Cet élément utilise le tag HTML défini par `TAG_FOLDER_LIST` et est rendu dans le Light DOM (pas de Shadow DOM).
 *
 * @category Group
 */
@Define({ tag: TAG_FOLDER_LIST })
@Light()
export class HTMLBnumFolderList extends BnumElement {
	/**
	 * Initialise une nouvelle instance du composant `HTMLBnumFolderList`.
	 */
	constructor() {
		super();
	}

	/**
	 * Méthode de préchargement interne du composant.
	 * Le décorateur `@SetAttr` applique automatiquement l'attribut HTML `role="group"`
	 * à l'élément lors de son cycle de vie.
	 * @protected
	 * @returns
	 */
	@SetAttr('role', 'group')
	protected _p_preload(): void {}

	/**
	 * Génère et retourne la structure JSX/TSX (ou chaîne de caractères) du composant `HTMLBnumFolderList`.
	 * * @static
	 * @param  content Le contenu (texte ou éléments enfants) à insérer à l'intérieur de la balise.
	 * @param  attrs Un dictionnaire (clé-valeur) représentant les attributs HTML à appliquer au composant.
	 * @returns L'élément rendu
	 */
	static Write(
		content: string = EMPTY_STRING,
		attrs: Record<string, string> = {},
	): string {
		if (attrs && Object.keys(attrs).length > 0)
			return <HTMLBnumFolderList {...attrs}>{content}</HTMLBnumFolderList>;
		else return <HTMLBnumFolderList>{content}</HTMLBnumFolderList>;
	}
}
